import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import $ from 'jquery';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';

import NavView from '../component/NavView';
import HomePosterView from '../component/home/HomePosterView';
import GamePosterView from '../component/home/GamePosterView';
import NewsSectionView from '../component/home/NewsSectionView';
import AboutSectionView from '../component/home/AboutSectionView';
import PageFooter from './PageFooter';
import SectionView from '../component/home/SectionView';
import { getImgPath } from '../store/JSTool';
import LogoAniView from '../component/LogoAniView';

export default function HomePage() {

    let navId = 'home_page_nav';
    let pageId = 'home_page_div';
    let sectionIdAry = ['home_works', 'home_news', 'home_about'];

    React.useEffect(() => {
        JSTool.addPageScrollListener(pageId, navId, window.innerHeight - 50, sectionIdAry);
    }, []);

    return (
        <Stack
            component={'div'}
            sx={{
                width: 1,
                height: '100vh',
                position: 'relative',
            }}>

            <NavView navId={navId} pageId={pageId} pageFlag={window.innerHeight - 50} />
            <Stack
                id={pageId}
                component={'div'}
                sx={{
                    width: 1,
                    overflow: 'auto',
                    position: 'relative',
                    alignItems: 'center',
                }} >
                <HomePosterView />

                <SectionView id={sectionIdAry[0]} title='Our Games' isBlack={true} />
                <GamePosterView />

                <SectionView id={sectionIdAry[1]} title='News' />
                <NewsSectionView />

                <SectionView id={sectionIdAry[2]} title='About' />
                <AboutSectionView />

                <Box
                    id='apj_logo_id'
                    component={'img'}
                    src={getImgPath('logo_black.png')}
                    sx={{
                        opacity: 0,
                        my: 3,
                        width: '300px',
                    }} />

                <PageFooter pageId={pageId} />
            </Stack>

            {/* logo 动画 */}
            {settingObj.showLogoAni && <LogoAniView />}

        </Stack>

    );
}